import { useEffect } from 'react';

/* The app shell pins the document so the signed-in layout can scroll its own
   content pane: index.css sets `html, body, #root { height: 100% }` and
   `body { overflow: hidden }`.

   The public pages (/onboarding/<token>, /docs/request/<token>) render inside
   that same #root with no shell, so the lock truncates them at one viewport —
   an employee could not reach step 3.

   The class goes on BOTH <html> and <body>. A body-scoped rule cannot release
   <html>, and <html> is the element that actually matters: left at height:100%
   it stays clamped to the viewport while its content overflows, which desktop
   Chrome still scrolls but mobile Safari does not. Releasing html + body to
   `height:auto; overflow:visible` restores ordinary document scrolling, which
   is also what keeps the "type your full name" input above the on-screen
   keyboard (a fixed full-screen overlay does not). Removed on unmount, so the
   signed-in shell is untouched. */
export default function usePublicPageScroll() {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('public-scroll');
    document.body.classList.add('public-scroll');
    return () => {
      html.classList.remove('public-scroll');
      document.body.classList.remove('public-scroll');
    };
  }, []);
}
